import $axios from "../request.js";
import qs from "qs";
const login = {
  // 预约
  register(params) {
    return $axios.post(
      "api/wap/reservatio/register/save",
      qs.stringify(params)
    );
  },
  // 预约详情
  getDetails(params) {
    return $axios.post(
      "api/wap/reservatio/register/getDetails",
      qs.stringify(params)
    );
  },
  // 预查询预约剩余数量
  getSurplus(params) {
    return $axios.post(
      "api/wap/reservatio/register/getSurplus",
      qs.stringify(params)
    );
  },
  // 预约列表
  queryPage(params) {
    return $axios.post(
      "api/wap/reservatio/register/queryPage",
      qs.stringify(params)
    );
  },
  reveal(params) {
    return $axios.post(
      "api/wap/reservatio/register/reveal",
      qs.stringify(params)
    );
  },
  // 取消预约
  cancel(params) {
    return $axios.post(
      "api/wap/reservatio/register/cancel",
      qs.stringify(params)
    );
  },
  // 获取预约时间
  getInfo(params) {
    return $axios.post(
      "api/wap/reservatio/sacrificeDateSetup/getInfo",
      qs.stringify(params)
    );
  },
  getWxUserInfoForWx(params) {
    return $axios.post("/api/wap/wx/getOpenId", qs.stringify(params));
  }
};

export default login;
